<template>
  <v-app>
    <navigation-drawer v-if="showDrawer" />
    <v-sheet v-if="!isAppInitialised">
      <splash-screen />
    </v-sheet>
    <v-sheet v-else class="fill-height">
      <app-bar
        v-if="showAppBar"
        :contract="contract"
      />
      <v-main
        light
        class="fill-height"
      >
        <router-view :contract="contract" />
      </v-main>
      <main-modal />
      <confirm-dialog />
      <snack-bar />
    </v-sheet>
    <v-footer
      v-if="isAppInitialised && showFooterBar"
      class="justify-end mt-10"
      :color="mapEnvAppColor"
    >
      <v-btn
        class="mr-4"
        color="primary"
        dark
        download
        href="/CCA Quick Start_updated_10.2025.pdf"
        rounded
        small
      >
        {{ $t('dictionaries.userManual') }}
        <v-icon class="ml-2" size="medium">mdi-file-document-outline</v-icon>
      </v-btn>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { isAppInitialised } from '@/store/getters'
import { initialiseApp } from './store/actions'
import { authContext } from '@/plugins/msalPlugin'
import {
  getAllContractors,
  getAllDictionaries,
  getAllEmployers,
  getContract
} from './services'
import { DEFAULT_CONTRACT, mapEnvAppColor } from '@/helpers'

export default {
  name: 'App',
  data () {
    return {
      contract: DEFAULT_CONTRACT,
      key: '1'
    }
  },
  async mounted () {
    this.$eventBus.$on('FETCH_CONTRACT', async () => {
      if (this.$route.params.contractId) {
        this.contract = await getContract(this.$route.params.contractId)
      } else {
        this.contract = DEFAULT_CONTRACT
      }
    })
    this.$eventBus.$on('SET_CURRENCY', (currency) => {
      this.contract.chosenCurrency = currency
    })
    this.$eventBus.$on('SET_LD_CAP', (updatedLiquidatedDamagesCap) => {
      this.contract.liquidatedDamagesCap = { ...updatedLiquidatedDamagesCap }
    })
    await this.$msal.signIn()
    await this.$msal.acquireToken()
    await this.$msal.acquireToken(['user.read', 'user.readbasic.all'])
    if (this.$route.name === null) {
      this.$router.replace({ name: 'contracts' })
    }
  },
  computed: {
    mapEnvAppColor,
    ...mapGetters([isAppInitialised]),
    ...mapState({
      isAdmin: (state) => state.isAdmin,
      isAreaManager: (state) => state.isAreaManager
    }),
    contractId () {
      return this.$route.params.contractId
    },
    showAppBar () {
      return !!this.$router.options.routes.find(
        (i) => i.name === this.$route.name
      )
    },
    showFooterBar () {
      return this.$route.name === 'contracts'
    },
    account () {
      return authContext.account
    },
    showDrawer () {
      return this.isAppInitialised
    }
  },
  watch: {
    async contractId (v) {
      this.contract = v ? await getContract(v) : DEFAULT_CONTRACT
    },
    account (v, p) {
      if (v && !p) {
        setTimeout(async () => {
          await getAllEmployers()
          await getAllContractors()
          await getAllDictionaries()
          if (this.$route.params.contractId) {
            this.contract = await getContract(this.$route.params.contractId)
          } else {
            this.contract = DEFAULT_CONTRACT
          }
          this.$store.dispatch(initialiseApp)
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.v-list-item__title {
  white-space: initial;
  text-align: center;
  font-size: 0.8rem;
}
</style>

<style>
.nowrap {
  white-space: nowrap;
}
.gap-sm {
  gap: 8px;
}
.gap-md {
  gap: 16px;
}

.glow-badge-success .v-badge__badge {
  box-shadow: 0 0 3px 0 rgba(0, 255, 0, 0.75);
}
.glow-badge-error .v-badge__badge {
  box-shadow: 0 0 3px 0 rgba(255, 0, 0, 0.5);
}
</style>
